var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2917 1.88968L15.7829 6.38089C17.1595 5.02737 17.2672 3.18166 15.8752 1.7974C14.491 0.420805 12.653 0.513091 11.2917 1.88968ZM9.18454 16.8168C9.65366 16.8168 10.0228 16.4554 10.0228 15.9863L10.0382 10.4261L12.2837 8.34195C13.1913 8.42654 14.1218 8.04971 14.9062 7.24991L10.4227 2.7587C9.6229 3.55081 9.26145 4.46597 9.35373 5.38113L2.22471 13.0408C1.90171 13.3869 1.87864 13.8175 2.25547 14.2559L1.21726 15.5709C1.07883 15.7478 1.09421 16.0016 1.27109 16.1785L1.49411 16.4092C1.671 16.5861 1.91709 16.6014 2.11705 16.4476L3.42442 15.4095C3.85508 15.794 4.29344 15.7632 4.63182 15.4479L8.35398 11.9949V15.9863C8.35398 16.4554 8.72313 16.8168 9.18454 16.8168ZM3.27061 13.7176L9.87669 6.78848C9.99973 6.98843 10.1458 7.17301 10.315 7.34988C10.4919 7.53446 10.6765 7.68826 10.8611 7.81131L3.95505 14.4097L3.27061 13.7176Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.8c98a43cd0105ef1db8aa25155ba6dd6.svg";
export { ForwardRef as ReactComponent };